import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    service: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
  e.preventDefault();

 if (isSubmitting) return; // prevent double submit
  setIsSubmitting(true);

  const { name, email, company, service, message } = formData;
  const messageDiv = document.getElementById('formMessage'); // You can add a div for messages below the form

  try {
    const response = await fetch('https://emailer8080.onrender.com/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email,
        name: name,
        clientName: 'EquiCore Nexus',
        clientEmail: 'preritagrawal08@gmail.com',
        company: company,
        service: service,
        message: message,
        weburl: 'ecnexus.co',
      }),
    });

    const data = await response.json();

    if (response.ok) {
      messageDiv.textContent = data.message || 'Submission successful!';
      messageDiv.className = 'text-green-600 mt-4 text-center font-medium py-3 px-4 bg-green-50 rounded-lg border border-green-200';
      setFormData({
        name: '',
        email: '',
        company: '',
        service: '',
        message: '',
      });
    } else {
      messageDiv.textContent = data.error || 'Submission failed';
      messageDiv.className = 'text-red-600 mt-4 text-center font-medium py-3 px-4 bg-red-50 rounded-lg border border-red-200 animate-pulse';
    }
  } catch (error) {
    console.error('Error:', error);
    messageDiv.textContent = 'Error connecting to the server';
    messageDiv.className = 'text-red-600 mt-4 text-center font-medium py-3 px-4 bg-red-50 rounded-lg border border-red-200 animate-pulse';
  } finally {
    setIsSubmitting(false);
  }
};


  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#0F172A] mb-4">Contact Us</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-[#3B82F6] to-emerald-500 mx-auto rounded-full"></div>
          <p className="text-xl text-gray-600 mt-6 max-w-3xl mx-auto">
            Have questions or ready to discuss your needs? Reach out to our team.
          </p>
        </div>
        
        <div className="flex flex-col lg:flex-row gap-12 max-w-6xl mx-auto">
          <div className="lg:w-1/2">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-gray-700 mb-2 font-medium">Name</label>
                  <input 
                    type="text" 
                    id="name" 
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#3B82F6] focus:border-transparent transition"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-gray-700 mb-2 font-medium">Email</label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#3B82F6] focus:border-transparent transition"
                    required
                  />
                </div>
              </div>
              <div>
                <label htmlFor="company" className="block text-gray-700 mb-2 font-medium">Company</label>
                <input 
                  type="text" 
                  id="company" 
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#3B82F6] focus:border-transparent transition"
                />
              </div>
              <div>
                <label htmlFor="service" className="block text-gray-700 mb-2 font-medium">Service Interest</label>
                <select 
                  id="service" 
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#3B82F6] focus:border-transparent transition"
                >
                  <option value="">Select a service</option>
                  <option value="financial-planning">Investment Banking</option>
                  <option value="fundraising">Mergers & Acquisitions</option>
                  <option value="vc-advisory">Private Equity</option>
                  <option value="capital-structuring">Investment & Wealth</option>
                  <option value="valuation">Corporates & Startups</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div>
                <label htmlFor="message" className="block text-gray-700 mb-2 font-medium">Message</label>
                <textarea 
                  id="message" 
                  name="message"
                  rows="5" 
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#3B82F6] focus:border-transparent transition"
                  required
                ></textarea>
              </div>
              <button 
  type="submit" 
  disabled={isSubmitting}
  className={`bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold transition shadow-lg w-full hover:-translate-y-1 hover:shadow-xl
    ${isSubmitting ? 'opacity-60 cursor-not-allowed' : ''}
  `}
>
  {isSubmitting ? 'Sending...' : 'Send Message'}
</button>

            </form>
            <div id="formMessage"></div>

          </div>
          
          <div className="lg:w-1/2">
  <div className="bg-white p-8 rounded-xl h-full border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
    <h3 className="text-2xl font-bold text-gray-900 mb-6 relative pb-4">
      Our Offices
      <span className="absolute bottom-0 left-0 w-12 h-1 bg-blue-500 rounded-full"></span>
    </h3>
    
    <div className="space-y-6">
      {/* Location Card - Enhanced */}
      <div className="flex items-start bg-gray-50/50 hover:bg-blue-50/50 p-4 rounded-lg transition-colors border border-gray-100">
        <div className="bg-blue-100 p-3 rounded-lg mr-4 flex-shrink-0">
          <i className="fas fa-map-marker-alt text-blue-600 text-lg"></i>
        </div>
        <div>
          <h4 className="font-semibold text-gray-900 text-lg mb-1">Delhi NCR</h4>
          <p className="text-gray-500 text-sm mt-2">Open 9AM - 6PM (IST)</p>
        </div>
      </div>
      
      {/* Phone Card - Enhanced */}
      {/* <div className="flex items-start bg-gray-50/50 hover:bg-blue-50/50 p-4 rounded-lg transition-colors border border-gray-100">
        <div className="bg-blue-100 p-3 rounded-lg mr-4 flex-shrink-0">
          <i className="fas fa-phone-alt text-blue-600 text-lg"></i>
        </div>
        <div>
          <h4 className="font-semibold text-gray-900 text-lg mb-1">+91 00000 00000</h4>
          <p className="text-gray-600"></p>
          <a href="tel:+"><p className="text-blue-600 text-sm mt-2 hover:underline cursor-pointer">Click to call</p></a>
        </div>
      </div> */}
      
      {/* Email Card - Enhanced */}
      <div className="flex items-start bg-gray-50/50 hover:bg-blue-50/50 p-4 rounded-lg transition-colors border border-gray-100">
        <div className="bg-blue-100 p-3 rounded-lg mr-4 flex-shrink-0">
          <i className="fas fa-envelope text-blue-600 text-lg"></i>
        </div>
        <div>
          <h4 className="font-semibold text-gray-900 text-lg mb-1">info@ecnexus.co</h4>
          <p className="text-gray-600"></p>
          <a href="mailto:info@ecnexus.co"><p className="text-blue-600 text-sm mt-2 hover:underline cursor-pointer">Write to us</p></a>
        </div>
      </div>
    </div>
    
    {/* Social Media Section - Enhanced */}
    <div className="mt-10 pt-6 border-t border-gray-100">
      <h4 className="font-semibold text-lg mb-5 text-gray-900">Connect With Us</h4>
      <div className="flex space-x-3">
        <a target="_blank" href="https://www.linkedin.com/company/equicore-nexus/" rel='noreferrer' 
           className="bg-gray-100 hover:bg-blue-600 hover:text-white w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 transform hover:-translate-y-1">
          <i className="fab fa-linkedin-in text-gray-700 hover:text-white text-lg" alt="LinkedIn"><span className="sr-only">LinkedIn</span></i>
        </a>
        <a target="_blank" href="https://www.facebook.com/share/1GEsbBkGKC/" rel='noreferrer' 
           className="bg-gray-100 hover:bg-blue-600 hover:text-white w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 transform hover:-translate-y-1">
          <i className="fab fa-facebook-f text-gray-700 hover:text-white text-lg" alt="Facebook"><span className="sr-only">Facebook</span></i>
        </a>
      </div>
    </div>
  </div>
</div>
        </div>
      </div>
    </section>
  );
};

export default Contact;